var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2222 12C16.2222 14.1478 14.4811 15.8889 12.3333 15.8889C10.1856 15.8889 8.44444 14.1478 8.44444 12C8.44444 9.85223 10.1856 8.11111 12.3333 8.11111C14.4811 8.11111 16.2222 9.85223 16.2222 12ZM14.6667 12C14.6667 13.2887 13.622 14.3333 12.3333 14.3333C11.0447 14.3333 10 13.2887 10 12C10 10.7113 11.0447 9.66667 12.3333 9.66667C13.622 9.66667 14.6667 10.7113 14.6667 12Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6667 12C21.6667 13.9444 17.488 19 12.3333 19C7.17868 19 3 14.3333 3 12C3 9.66667 7.17868 5 12.3333 5C17.488 5 21.6667 10.0556 21.6667 12ZM20.1108 11.9992L20.1109 12L20.1108 12.0008C20.1089 12.0162 20.0972 12.1127 20.0246 12.3022C19.9445 12.511 19.8123 12.776 19.6182 13.0831C19.2298 13.6978 18.6433 14.4029 17.8974 15.0684C16.3863 16.4167 14.4061 17.4444 12.3333 17.4444C10.2234 17.4444 8.2372 16.4815 6.75027 15.1976C6.01291 14.5609 5.43762 13.8778 5.05738 13.2614C4.65578 12.6104 4.55556 12.1723 4.55556 12C4.55556 11.8277 4.65578 11.3896 5.05738 10.7386C5.43762 10.1222 6.01291 9.43906 6.75027 8.8024C8.2372 7.51854 10.2234 6.55556 12.3333 6.55556C14.4061 6.55556 16.3863 7.58333 17.8974 8.93155C18.6433 9.59711 19.2298 10.3022 19.6182 10.9169C19.8123 11.224 19.9445 11.489 20.0246 11.6978C20.0972 11.8873 20.1089 11.9838 20.1108 11.9992Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.7816ed0e2d0bdb0ab9562112cef51224.svg";
export { ForwardRef as ReactComponent };